import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import OrganizationInfo from '../components/organization/OrganizationInfo';
import UsersAndContacts from '../components/organization/UsersAndContacts';

function OrganizationView() {
  const { t } = useTranslation();
  const TabValues = Object.freeze({
    INFO: 'info',
    USERS: 'users',
    valueOf(index) {
      switch (index) {
        case 0:
          return TabValues.INFO;
        case 1:
        default:
          return TabValues.USERS;
      }
    },
    indexOf(value) {
      switch (value) {
        case TabValues.INFO:
          return 0;
        case TabValues.USERS:
        default:
          return 1;
      }
    },
  });

  const [selectedTab, setSelectedTab] = useState(TabValues.INFO);

  const handleChange = (_, index) => {
    setSelectedTab(TabValues.valueOf(index));
  };

  function renderTabContents(tab) {
    switch (tab) {
      case TabValues.USERS:
        return <UsersAndContacts />;
      case TabValues.INFO: // Intentional fallthrough
      default:
        return <OrganizationInfo />;
    }
  }

  return (
    <Box sx={{ p: '32px', maxWidth: '1200px', maxHeight: '99vh', overflowY: 'auto' }}>
      <Stack direction="column" spacing={4}>
        <Stack direction="column" spacing={3}>
          <Typography id='settings-title' variant="title">{t('organization.settings')}</Typography>
          <Typography variant="settingsDesc" sx={{ maxWidth: '900px' }}>{t('organization.settingsDesc')}</Typography>
        </Stack>
        <Tabs variant="fullWidth" value={TabValues.indexOf(selectedTab)} onChange={handleChange}>
          <Tab id='organizational-info-tab' label={t('organization.infoTitle')} />
          <Tab id='users-and-contacts-tab' label={t('organization.contact')} />
        </Tabs>
        {renderTabContents(selectedTab)}
      </Stack>
    </Box>
  );
}

export default OrganizationView;
